import styled from 'styled-components';

export const InputStyled = styled.input`
    border: 3px solid transparent;
    outline: none;
    font-size: 40px;
    padding: 10px 15px;
    border-radius: 20px;
    font-family: 'Rubik', sans-serif;
    box-shadow: 0 2px 3px hsl(0deg 0% 0% / 0.3);

    &:focus {
        border: 3px solid #E0AE4A;
        box-shadow: none;
    }

    @media screen and (max-width: 576px){
        font-size: 30px;
    }
`;